import React from "react";

import { ReactComponent as AppUsersIcon } from "@common/assets/images/sidebar-icons/app-users-icon.svg";
import { ReactComponent as CrashReportsIcon } from "@common/assets/images/sidebar-icons/crash-reports-icon.svg";
import { ReactComponent as InfoIcon } from "@common/assets/images/sidebar-icons/info-module.svg";
import { ReactComponent as ReleasesIcon } from "@common/assets/images/sidebar-icons/releases-icon.svg";
import { ReactComponent as UserFeedbackIcon } from "@common/assets/images/sidebar-icons/user-feedback-icon.svg";
import RoundedCanvas from "@common/components/RoundedCanvas/RoundedCanvas";
import identifiers from "@common/util/identifiers.json";
import SidebarLink from "@main/layouts/components/Sidebar/SidebarLink";

import * as Styles from "./Layouts.styles";

export function Layouts() {
  return (
    <Styles.SidebarWrap
      className="sidebar"
      $active={false}
    >
      <Styles.SidebarTop>
        <Styles.SidebarIconWrap>
          <Styles.SidebarCanvasWrap>
            <RoundedCanvas
              testId={identifiers["main.workspaceIcon"]}
              image={undefined}
              arrow={"down"}
            />
          </Styles.SidebarCanvasWrap>
        </Styles.SidebarIconWrap>
      </Styles.SidebarTop>

      <Styles.SidebarLinks>
        <Styles.CluesDiv>
          <SidebarLink
            to={"/"}
            icon={<ReleasesIcon />}
            disabled={true}
            label="Releases"
          />

          <SidebarLink
            to={"/"}
            icon={<UserFeedbackIcon />}
            testId={identifiers["main.moduleIcon.userFeedback"]}
            disabled={true}
            label="Feedback"
          />

          <SidebarLink
            to={"/"}
            icon={<CrashReportsIcon />}
            testId={identifiers["main.moduleIcon.crashReports"]}
            disabled={true}
            label="Crashes"
          />

          <SidebarLink
            to={"/"}
            icon={<AppUsersIcon />}
            testId={identifiers["main.moduleIcon.users"]}
            disabled={true}
            label="Users"
          />

          <SidebarLink
            to={"/"}
            icon={<InfoIcon />}
            disabled={true}
            label="Info"
          />
        </Styles.CluesDiv>
      </Styles.SidebarLinks>

      <Styles.SidebarBottom>
        <Styles.SidebarIconWrap>
          <Styles.SidebarCanvasWrap>
            <RoundedCanvas
              testId={identifiers["main.profileIcon"]}
              image={undefined}
              arrow={"down"}
            />
          </Styles.SidebarCanvasWrap>
        </Styles.SidebarIconWrap>
      </Styles.SidebarBottom>
      <Styles.ModalOverlay $active={false} />
    </Styles.SidebarWrap>
  );
}
